// ENTITY fr.gestionpial.pial.dto.DashboardDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { DashboardEcoleDTO } from './DashboardEcoleDTO';
import { DashboardAlerteDTO } from './DashboardAlerteDTO';

export class DashboardDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.DashboardDTO';

  nbAesh: number | null = 0;
  nbAbsences: number | null = 0;
  nbEcoles: number | null = 0;
  nbClasses: number | null = 0;
  totalContratMinutes: number | null = 0;
  totalAffecteMinutes: number | null = 0;
  nbNotifications: number | null = 0;
  nbNotifI: number | null = 0;
  nbNotifM: number | null = 0;
  totalNotifIMinutes: number | null = 0;
  totalReserveMinutes: number | null = 0;
  totalBesoinNotifMinutes: number | null = 0;
  totalPlanifieMinutes: number | null = 0;
  nbNotifPlanifiees100: number | null = 0;
  ecoles: DashboardEcoleDTO[] | null = [];
  alertes: DashboardAlerteDTO[] | null = [];

  constructor(init?:Partial<DashboardDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.DashboardDTO'] = DashboardDTO;

fields['fr.gestionpial.pial.dto.DashboardDTO']  = {
    nbAesh: 'java.lang.Integer',
    nbAbsences: 'java.lang.Integer',
    nbEcoles: 'java.lang.Integer',
    nbClasses: 'java.lang.Integer',
    totalContratMinutes: 'java.lang.Integer',
    totalAffecteMinutes: 'java.lang.Integer',
    nbNotifications: 'java.lang.Integer',
    nbNotifI: 'java.lang.Integer',
    nbNotifM: 'java.lang.Integer',
    totalNotifIMinutes: 'java.lang.Integer',
    totalReserveMinutes: 'java.lang.Integer',
    totalBesoinNotifMinutes: 'java.lang.Integer',
    totalPlanifieMinutes: 'java.lang.Integer',
    nbNotifPlanifiees100: 'java.lang.Integer',
    ecoles: 'java.util.List<fr.gestionpial.pial.dto.DashboardEcoleDTO>',
    alertes: 'java.util.List<fr.gestionpial.pial.dto.DashboardAlerteDTO>'
};
